export default "data:text/javascript;base64,aW1wb3J0IFRTa2VsZXRvbiBmcm9tICIuL1RTa2VsZXRvbi52dWUiOwoKZXhwb3J0IGRlZmF1bHQgVFNrZWxldG9uOwo="